module.exports = __webpack_public_path__ + "img/2.20fc26a5.jpg";